/* Ghost sizes quick-add behaviour (owner brief quick-add-ghost-sizes.md).
 * One tap on a .qa-size button adds that exact variant via /cart/add.js.
 * Buttons carrying data-open-modal (a size stocked in more than one
 * colour) instead click the card's hidden Dawn modal-opener button, so
 * the existing quick-add modal flow handles the colour choice.
 * After a direct add, the cart bubble and drawer HTML refresh quietly
 * using the same Section Rendering recipe as cart-drawer.js
 * renderContents, minus the open() call - the ADDED frame is the
 * confirmation, the drawer must not pop over it.
 */
(function () {
  var CONFIRM_MS = 1600;

  function sectionInner(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshCart(sections) {
    if (!sections) return;

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var bubbleInner = sectionInner(sections['cart-icon-bubble'], '.shopify-section');
      if (bubbleInner !== null) bubble.innerHTML = bubbleInner;
    }

    var drawer = document.querySelector('cart-drawer');
    var drawerContents = document.querySelector('#CartDrawer');
    if (drawer && drawerContents && sections['cart-drawer']) {
      var drawerInner = sectionInner(sections['cart-drawer'], '#CartDrawer');
      if (drawerInner !== null) {
        drawerContents.innerHTML = drawerInner;
        drawer.classList.remove('is-empty');
        var innerWrap = drawer.querySelector('.drawer__inner');
        if (innerWrap) innerWrap.classList.remove('is-empty');
        var overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      }
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.qa-size');
    if (!btn || btn.disabled) return;
    var card = btn.closest('.card-wrapper');
    if (!card) return;
    event.preventDefault();

    if (btn.hasAttribute('data-open-modal')) {
      var opener = card.querySelector('.quick-add modal-opener button');
      if (opener) opener.click();
      return;
    }

    if (btn.hasAttribute('data-qa-busy')) return;
    btn.setAttribute('data-qa-busy', '1');

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }],
        sections: 'cart-icon-bubble,cart-drawer'
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function (data) {
        refreshCart(data.sections);
        var added = card.querySelector('.qa-added');
        if (!added) return;
        var meta = added.querySelector('.qa-added__meta');
        var size = btn.getAttribute('data-qa-size');
        if (meta) meta.textContent = size ? 'Size \u2014 ' + size : btn.textContent.trim();
        added.hidden = false;
        window.setTimeout(function () {
          added.hidden = true;
        }, CONFIRM_MS);
      })
      .catch(function () {
        /* on error, leave the UI unchanged (brief) */
      })
      .finally(function () {
        btn.removeAttribute('data-qa-busy');
      });
  });
})();
